import Supplier from '@/entities/Supplier';

export default class SupplierService {
  constructor(db) {
    this.db = db;
  }

  async listByShopId(shopId) {
    const snap = await this.db
      .collection('shops')
      .doc(shopId)
      .collection('suppliers')
      .get();
    const list = [];
    snap.forEach((doc) => { list.push(new Supplier({ ...doc.data(), id: doc.id })); });

    return list;
  }
}
